
































































































































































































































import { Component, Mixins, Watch } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import BaseServiceMixin from "../mixins/base.service.mixin";
import CompanyService from "../services/company.service";
import { TwilioSettingsModel } from "../models/TwilioSettingsModel";
import TwilioConfigurationModel, { ConfigurationModel } from "../models/TwilioConfigurationModel";
import { TwilioSettings } from "../common/enum";
import eventBus from "../common/bus";
import Shared from "../common/shared";
import TwilioCredentialsModel from "../models/TwilioCredentialsModel";

@Component({
  components: {
    ValidationObserver,
  },
})
export default class TwilioSetting extends Mixins(BaseServiceMixin) {
  private companyService!: CompanyService;
  private twilioSettings: TwilioSettingsModel[] = [];
  private twilioConfigurations: TwilioConfigurationModel = new TwilioConfigurationModel();
  private twilioCredentials: TwilioCredentialsModel = new TwilioCredentialsModel();
  private twilioWorkflows: ConfigurationModel[] = [];
  private isTwilioCredentialsValid = false;
  private isOpen = 0;

  private accountSid: TwilioSettingsModel = {
    keyType: TwilioSettings.AccountSid,
  } as TwilioSettingsModel;

  private authToken: TwilioSettingsModel = {
    keyType: TwilioSettings.APIKey,
  } as TwilioSettingsModel;

  private workspaceSid: TwilioSettingsModel = {
    keyType: TwilioSettings.WorkspaceSid,
  } as TwilioSettingsModel;

  private applicationSid: TwilioSettingsModel = {
    keyType: TwilioSettings.ApplicationSid,
  } as TwilioSettingsModel;

  private workflowSid: TwilioSettingsModel = {
    keyType: TwilioSettings.WorkerTransferWorkflowSid,
  } as TwilioSettingsModel;

  private callerId: TwilioSettingsModel = {
    keyType: TwilioSettings.CallerId,
  } as TwilioSettingsModel;

  private get isTwilioSetup(): boolean {
    return this.vuexStore.user ? this.vuexStore.user.isTwilioSetup : false;
  }

  public created() {
    this.companyService = new CompanyService(this.axiosInstance);
  }

  private async mounted() {
    if (this.isTwilioSetup) {
      await this.getTwilioSettings();
    }
  }

  private async getTwilioSettings() {
    eventBus.$emit("loading", true);
    try {
      this.twilioSettings = await this.companyService.getTwilioSettings();
      if (this.twilioSettings.length) {
        this.isTwilioCredentialsValid = this.isTwilioSetup;

        await this.getTwilioConfigurations();
        this.populateTwilioSettings();
        await this.getTwilioWorkflows();

        this.isOpen = 1;
      }
    } catch (error) {
      // Handle error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private populateTwilioSettings() {
    if (this.twilioSettings && this.twilioSettings.length) {
      this.twilioSettings.forEach((setting: TwilioSettingsModel) => {
        let exist = true;

        switch (setting.keyType) {
          case TwilioSettings.AccountSid:
            this.accountSid.value = setting.value;
            break;
          case TwilioSettings.WorkspaceSid:
            if (this.twilioConfigurations.workspaces.length) {
              exist = this.twilioConfigurations.workspaces.some(
                (workspace: ConfigurationModel) => workspace.sid === setting.value,
              );
            }
            this.workspaceSid.value = exist ? setting.value : "";
            break;
          case TwilioSettings.ApplicationSid:
            if (this.twilioConfigurations.workspaces.length) {
              exist = this.twilioConfigurations.applications.some(
                (application: ConfigurationModel) => application.sid === setting.value,
              );
            }
            this.applicationSid.value = exist ? setting.value : "";
            break;

          case TwilioSettings.WorkerTransferWorkflowSid:
            if (this.twilioWorkflows.length) {
              exist = this.twilioWorkflows.some((workflow: ConfigurationModel) => workflow.sid === setting.value);
            }
            this.workflowSid.value = exist ? setting.value : "";
            break;

          case TwilioSettings.CallerId:
            this.callerId.value = setting.value;
            break;
        }
      });
    }
  }

  @Watch("isTwilioSetup")
  private async getTwilioConfigurations() {
    if (this.isTwilioSetup) {
      this.twilioConfigurations = await this.companyService.getTwilioConfigurations(this.twilioCredentials);
      this.isTwilioCredentialsValid = true;
    }
  }

  private async validateTwilioSettings() {
    const settingsArray: TwilioSettingsModel[] = [];

    if (this.accountSid.value) {
      settingsArray.push(this.accountSid);
      this.twilioCredentials.accountSid = this.accountSid.value;
    }
    if (this.authToken.value) {
      settingsArray.push(this.authToken);
      this.twilioCredentials.authToken = this.authToken.value;
    }

    if (!settingsArray.length) {
      return;
    }

    eventBus.$emit("loading", true);
    try {
      this.twilioConfigurations = await this.companyService.getTwilioConfigurations(this.twilioCredentials);
      this.isTwilioCredentialsValid = true;
      this.isOpen = 1;
      this.resetTwilioConfiguration();
    } catch (error) {
      // Handle Error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private resetTwilioConfiguration() {
    this.applicationSid = {
      keyType: TwilioSettings.ApplicationSid,
    } as TwilioSettingsModel;

    this.workspaceSid = {
      keyType: TwilioSettings.WorkspaceSid,
    } as TwilioSettingsModel;

    this.workflowSid = {
      keyType: TwilioSettings.WorkerTransferWorkflowSid,
    } as TwilioSettingsModel;

    this.callerId = {
      keyType: TwilioSettings.CallerId,
    } as TwilioSettingsModel;
    this.twilioWorkflows = [];
  }

  private async saveTwilioSettings() {
    const settingsArray: TwilioSettingsModel[] = [
      this.workspaceSid,
      this.applicationSid,
      this.workflowSid,
      this.callerId,
    ];

    if (this.accountSid.value && this.authToken.value) {
      settingsArray.push(this.accountSid);
      settingsArray.push(this.authToken);
    }

    eventBus.$emit("loading", true);
    try {
      await this.companyService.upsertTwilioSettings(settingsArray);

      Shared.showToastMessage(Shared.messages.TWILIO_SETTINGS_SAVE_SUCCESSFUL, "is-success");

      if (!this.isTwilioSetup) {
        eventBus.$emit("refresh-profile");
      }
      this.authToken = {
        keyType: TwilioSettings.APIKey,
      } as TwilioSettingsModel;

      await this.getTwilioSettings();
    } catch (error) {
      // Handle Error
    } finally {
      eventBus.$emit("loading", false);
    }
  }

  private async getTwilioWorkflows() {
    if (this.isTwilioCredentialsValid && this.workspaceSid.value) {
      eventBus.$emit("loading", true);
      try {
        const twilioWorkflows = await this.companyService.getTwilioWorkflows(
          this.twilioCredentials,
          this.workspaceSid.value,
        );
        this.twilioWorkflows = [];

        if (twilioWorkflows.length) {
          this.twilioWorkflows = twilioWorkflows;
          const exist = this.twilioWorkflows.some(
            (workflow: ConfigurationModel) => workflow.sid === this.workflowSid.value,
          );
          if (!exist) {
            this.workflowSid = {
              keyType: TwilioSettings.WorkerTransferWorkflowSid,
            } as TwilioSettingsModel;
          }
        }
      } catch (error) {
        // Handle error
      } finally {
        eventBus.$emit("loading", false);
      }
    }
  }
}
